<template>
  <div class="appt-confirm">
    <div class="appt-cap1 t-bold">Confirm Personalized Coupon</div>
    <div
      v-if="(!couponComplete() && !useServices) || (!formServiceComplete && useServices)"
      class="text-center mx-auto d-flex justify-content-center align-items-center flex-column"
    >
      <p
      v-if="!useServices"
        class="text-center text-red d-flex justify-content-center align-items-center mx-auto"
      >
        You must select a coupon to continue
      </p>
      <p
      v-else
        class="text-center text-red d-flex justify-content-center align-items-center mx-auto"
      >
        You must select one or more services to continue
      </p>
      <div
        class="btn-next btn-book c-pointer d-flex flex-row align-items-center"
        @click="gotoEdit(1)"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          fill="currentColor"
          class="bi bi-arrow-left"
          viewBox="0 0 16 16"
        >
          <path
            fill-rule="evenodd"
            d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8z"
          />
        </svg>
        <p class="mb-0 ml-3">Go to Coupons</p>
      </div>
    </div>
    <div class="w-100 mt-2" v-if="validationErrors()">
      <p class="w-100 text-center text-red text-italic">
        <strong v-if="validationErrors()"
          >Form not completed. Please correct the following fields and try
          again.</strong
        >
      </p>

      <p class="w-100 text-center text-red">
        <span v-for="(error, index) in validationErrors()" :key="index">{{
          error[0]
        }}</span>
      </p>
    </div>
    <div class="appt-confirm-stages">
      <div class="confirm-stage active">
        <div class="d-title">
          <span class="lbl-cap8 text-bold">Store Selected</span>
          <div class="action-edit" @click="gotoEdit(0)" v-if="formStore">
            Edit
          </div>
        </div>
        <div class="d-detail" v-if="formStore">
          <div class="lbl-cap6 text-bold">
            Tint World<sup>&reg;</sup> {{ formStore().address.city }}
          </div>
          <div class="lbl-cap6">
            {{ formStore().address.street }}, Suite #{{
              formStore()["location-id"]
            }}
          </div>
          <div class="lbl-cap6">
            {{ formStore().address.city }},
            {{ formStore().address.region }}
            {{ formStore().address.postalCode }}
          </div>
        </div>
      </div>
      <div class="confirm-stage active" v-if="couponComplete() && !useServices">
        <div class="d-title">
          <span class="lbl-cap8 text-bold">Selected Coupon</span>
          <div class="action-edit" @click="gotoEdit(1)">Edit</div>
        </div>
        <div class="d-detail" v-if="couponComplete()">
          <div class="lbl-cap6 text-cap" v-if="couponComplete()">
            {{ selectedCoupon().offer_red_text.toLowerCase() }}
            {{ selectedCoupon().offer_text_top.toLowerCase() }}
            {{ selectedCoupon().offer_subline.toLowerCase() }}
          </div>
        </div>
      </div>
      <div
        class="confirm-stage active"
        v-else-if="useServices && formServiceComplete"
      >
        <div class="d-title">
          <span class="lbl-cap8 text-bold">Selected Services</span>
          <div class="action-edit" @click="gotoEdit(1)">Edit</div>
        </div>
        <div class="d-detail">
          <div class="lbl-cap6 text-cap">
            <span v-for="service in formServiceStore()" :key="service.id"
              >{{ service.category }} - {{ service.name }},
            </span>
          </div>
        </div>
      </div>
      <div class="confirm-stage active">
        <div class="d-title">
          <span class="lbl-cap8 text-bold">Contact Info:</span>
          <div
            class="action-edit"
            @click="gotoEdit(2)"
            v-if="user().first_name"
          >
            Edit
          </div>
        </div>
        <div class="d-detail" v-if="user().first_name">
          <div class="flex-1 d-flex flex-column">
            <div class="flex-1 md-b15"></div>
            <div class="flex-1 md-b15">
              <div class="lbl-cap7 text-bold">Your Info</div>
              <div class="lbl-cap6">
                {{ user().first_name }}
                {{ user().last_name }}
              </div>
              <div class="lbl-cap6">{{ user().phone }}</div>
              <div class="lbl-cap6">{{ user().email }}</div>
            </div>
            <div class="flex-1 md-b15">
              <div class="lbl-cap7 text-bold">About My Project</div>
              <div class="lbl-cap6">{{ user().notes }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="goto-next">
      <div class="btn-back c-pointer" @click="back">Back</div>
      <div
        class="btn-next btn-book c-pointer"
        :class="{ active: couponComplete() || formServiceComplete }"
        @click="process_form"
      >
        Book Now
      </div>
      <!-- <div class="btn-next btn-book c-pointer active" v-if="formProcessing">
        Processing
      </div> -->
    </div>
  </div>
</template>
<script>
export default {
  data: () => {
    return {};
  },
  props: {
    useServices: Boolean,
  },
  computed: {
    formServiceComplete() {
      return this.$store.getters.formServices;
    },
    appointment() {
      return this.$store.state.appointment;
    },
    service_type() {
      return this.$store.state.appointment.service.service;
    },
  },
  methods: {
    validationErrors() {
      if (this.$store.getters.affiliateErrors) {
        return Object.values(this.$store.getters.affiliateErrors);
      } else return false;
    },
    couponComplete() {
      return this.$store.getters.formCoupons;
    },
    back() {
      this.$store.commit("setAffiliateErrors", null);
      this.$emit("back");
    },
    process_form() {
      const vm = this;
      this.$store.dispatch("submitAffiliateLead").then(function () {
        vm.$gtm.trackEvent({
          event: "generate_lead",
          category: "Lead",
          action: vm.formType + " lead captured",
          label: "",
          noninteraction: false,
        });
      });
    },
    user() {
      return this.$store.state.user;
    },
    selectedCoupon() {
      return this.$store.state.coupons.selectedCoupon;
    },
    formServiceStore() {
      return this.$store.state.user.services;
    },
    formStore() {
      return this.$store.state.user.selectedStoreForInquiry;
    },
    gotoEdit(int) {
      // appt_store | appt_service | appt_date | appt_contact | appt_confirm
      this.$emit("gotoEdit", int);
    },
  },
};
</script>

<style>
.text-red {
  color: #e61d25;
}
</style>
